import React, { useState, useEffect } from 'react';
import './App.css';
import ContentDisplay from './components/ContentDisplay';
import AddContentModal from './components/AddContentModal';

function App() {
  const [items, setItems] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // API URL configuration
  const getApiBaseUrl = () => {
    const hostname = window.location.hostname;
    const port = window.location.port;
    
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      // If running static build (port 8891), use Express.js server  
      if (port === '8891') {
        return 'http://localhost:8080';
      }
      // If running React dev server (port 3000), use Wrangler Pages (port 8890 for Docker)
      if (port === '3000') {
        return 'http://localhost:8890';
      }
      // If running on port 8888 or 8890 (Wrangler Pages), use current origin
      if (port === '8888' || port === '8890') {
        return window.location.origin;
      }
      // Fallback to Express.js server
      return 'http://localhost:8080';
    }
    
    // Production - temporarily use pages.dev for Functions until custom domain routing is fixed
    if (hostname.includes('paullikes.xyz')) {
      return 'https://paul-likes.pages.dev';
    }
    return window.location.origin;
  };
  
  const apiBaseUrl = getApiBaseUrl();

  useEffect(() => {
    loadItems();
    
    // Auto-refresh every 2 minutes
    const interval = setInterval(loadItems, 120000);
    return () => clearInterval(interval);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadItems = async () => {
    try {
      const response = await fetch(`${apiBaseUrl}/api/items?limit=50`);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      
      const data = await response.json();
      setItems(data.items || []);
      setError(null);
    } catch (err) {
      console.error('Failed to load items:', err);
      setError('Failed to load content');
      // Fallback content
      setItems([
        {
          content: "https://assets.simpleviewinc.com/simpleview/image/upload/c_fill,h_459,q_75,w_1908/v1/clients/austin/Barton_Springs_Pool_Sunset_Credit_Ryan_Kyte_Lifetime_Usage_ecf590c9-1679-45a5-ad54-afa1fddc7a3f.jpg",
          type: "image",
          caption: "Barton Springs Pool - Austin, TX"
        }
      ]);
    } finally {
      setLoading(false);
    }
  };

  const handleAddContent = async (newItem) => {
    try {
      const response = await fetch(`${apiBaseUrl}/api/add-item`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newItem)
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Failed to add content');
      }

      const result = await response.json();
      
      // Add new item to the beginning of the list
      setItems(prev => [result.item, ...prev]);
      setIsModalOpen(false);
      
      return { success: true };
    } catch (err) {
      console.error('Failed to add content:', err);
      return { success: false, error: err.message };
    }
  };

  return (
    <div className="App">
      <div className="container">
        <h1>Paul Likes...</h1>
        
        <ContentDisplay 
          items={items}
          loading={loading}
          error={error}
        />
        
        <button 
          className="add-content-btn"
          onClick={() => setIsModalOpen(true)}
        >
          ➕ Add Content
        </button>
      </div>

      {isModalOpen && (
        <AddContentModal
          onClose={() => setIsModalOpen(false)}
          onAdd={handleAddContent}
        />
      )}
    </div>
  );
}

export default App;